/* @flow */
import React, { type Node } from 'react';

import { getColor, getRatingBackgroundColor, roundToAccuracy } from '../../utils';

import { Corner, Inside, Root, Tooltip, Value } from './styles';

type TProps = {
	type?: string,
	value?: number | number[],
	tooltip?: string,
	tooltipNative?: string,
	tooltipRight?: string,
	dataQa?: string,
};

const RatingMark = ({ type, value, tooltip, tooltipNative, tooltipRight, dataQa }: TProps): Node => {
	const colorRating = getColor(type, value);
	const backgroundColorRating = getRatingBackgroundColor(type, value);
	const Body = (): Node => {
		switch (type) {
			case 'text':
				return <Value $color={colorRating}>{roundToAccuracy(value)}</Value>;
			case 'inline':
				return (
					<span style={{ backgroundColor: backgroundColorRating, borderRadius: '128px', color: colorRating }}>
						{roundToAccuracy(value)}
					</span>
				);
			default:
				return (
					<Inside>
						<Value>{roundToAccuracy(value)}</Value>
					</Inside>
				);
		}
	};

	return (
		<Root type={type} borderColor={colorRating} title={tooltipNative || null} data-qa={dataQa || null}>
			{type === 'label' || type === 'label-transparent' ? <Corner $borderColor={colorRating} /> : null}

			<Body />

			{tooltip && <Tooltip $isRight={tooltipRight}>{tooltip}</Tooltip>}
		</Root>
	);
};

RatingMark.defaultProps = {
	value: 0,
	type: 'label',
	tooltip: null,
	tooltipNative: null,
	tooltipRight: null,
	dataQa: null,
};

export default RatingMark;
